import { render, staticRenderFns } from "./IconsMark.vue?vue&type=template&id=1a9bcb7a&scoped=true&"
import script from "./IconsMark.vue?vue&type=script&lang=js&"
export * from "./IconsMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9bcb7a",
  null
  
)

export default component.exports